<script setup lang="ts">
import { ASSETS, LX_BIDS } from './constants'
</script>

<template>
  <section 
    class="patent-section"
    :data-mv-bid="LX_BIDS.techMv"
    data-mv-key="patent"
    :data-mv-video-name="2"
  >
    <div class="patent-inner">
      <div class="patent-badge">
        <span class="patent-year">2026</span>
        <span class="patent-divider" aria-hidden="true" />
        <span class="patent-title">数字人专利获奖</span>
        <span class="patent-divider" aria-hidden="true" />
        <span class="patent-brand">美团智播</span>
      </div>
      <div class="patent-award-row">
        <img
          class="patent-ornament"
          :src="ASSETS.patentOrnamentLeft"
          alt=""
          aria-hidden="true"
          width="68"
          height="102"
        >
        <div class="patent-award">中国多媒体企业创新技术奖</div>
        <img
          class="patent-ornament"
          :src="ASSETS.patentOrnamentRight"
          alt=""
          aria-hidden="true"
          width="68"
          height="102"
        >
      </div>
    </div>

    <div class="patent-media" aria-hidden="true">
      <img class="patent-ribbon" :src="ASSETS.patentRibbon" alt="">
      <img
        class="patent-medal"
        :src="ASSETS.patentMedal"
        alt="中国多媒体企业创新技术奖奖牌"
        width="570"
        height="380"
      >
    </div>
  </section>
</template>

<style scoped lang="scss">
.patent-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin: 160px 0 0;
}

.patent-inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 1200px;
  max-width: calc(100% - 48px);
}

.patent-badge {
  display: flex;
  align-items: center;
  gap: 29px;
  color: #a77a00;
  font-size: 30px;
  font-weight: 500;
}

.patent-year {
  font-size: 34px;
  font-weight: 400;
}

.patent-divider {
  width: 1px;
  height: 35px;
  background: #a77a00;
}

.patent-award-row {
  display: flex;
  align-items: center;
  gap: 24px;
  margin-top: 24px;
}

.patent-ornament {
  flex: none;
  width: 68px;
  height: 102px;
  object-fit: contain;
}

.patent-award {
  color: transparent;
  background: linear-gradient(96deg, #a77a00 0%, #e5b85c 36%, #a77a00 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: 53px;
  font-weight: 700;
  line-height: normal;
  white-space: nowrap;
}

/* 通栏媒体区：相对页面全宽，飘带贴齐左右 */
.patent-media {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 380px;
  margin-top: 48px;
  overflow: visible;
}

/* 飘带：从屏幕左侧铺到右侧，无留白 */
.patent-ribbon {
  position: absolute;
  inset: 0;
  z-index: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  pointer-events: none;
  user-select: none;
}

/* 上层奖牌：固定 570×380 */
.patent-medal {
  position: relative;
  z-index: 1;
  flex: none;
  width: 570px;
  max-width: min(570px, calc(100vw - 32px));
  height: 380px;
  object-fit: contain;
}

@media (max-width: 960px) {
  .patent-section {
    margin: 64px 0 0;
  }

  .patent-inner {
    width: auto;
    max-width: none;
    padding: 0 20px;
  }

  .patent-badge {
    flex-wrap: wrap;
    justify-content: center;
    gap: 12px;
    font-size: 18px;
  }

  .patent-year {
    font-size: 22px;
  }

  .patent-award {
    font-size: 28px;
    white-space: normal;
    text-align: center;
  }

  .patent-ornament {
    display: none;
  }

  .patent-media {
    min-height: 0;
    aspect-ratio: 570 / 380;
  }

  .patent-medal {
    width: calc(100vw - 40px);
    height: auto;
    aspect-ratio: 570 / 380;
  }
}
</style>
